import React from 'react';
import { designBaseUrl } from '../../lib/FL';

import contentCommonStyles from './ContentPreview.module.scss';
import styles from './BukkenListDetailPreview.module.scss';

type Props = {
  device: string;
};

const BukkenDetailPreview: React.FC<Props> = ({ device }) => (
  <div className={contentCommonStyles.content}>
    <ul className={styles.content__main}>
      <li>
        <img
          src={`${designBaseUrl}/assets/formatline/design/${device}/type009/color09/detail.png`}
          alt='サンプル画像'
        />
      </li>
    </ul>
  </div>
);

export default BukkenDetailPreview;
